export default "<div *ngIf=\"!!book\">{{book.name}}</div>\n"